import gql from 'graphql-tag';

export const GRAPHQL_QUERY_TAGS = gql`
    query tags($criteria: CriteriaInput!) {
        tags(criteria: $criteria) {
            rows {
                id
                name
                isActive
                createdAt
                updatedAt
                totalReceipts
            }
            total
            id
        }
    }
`;

export const GRAPHQL_MUTATION_ADD_TAG = gql`
    mutation addtag($tagInput: AddTagInput!) {
        addTag(tagInput: $tagInput) {
            id
            isActive
        }
    }
`;

export const GRAPHQL_MUTATION_UPDATE_TAG = gql`
    mutation updateTag($tagInput: UpdateTagInput!) {
        updateTag(tagInput: $tagInput) {
            id
            isActive
        }
    }
`;

export const GRAPHQL_MUTATION_DELETE_TAG = gql`
    mutation deleteTag($tagInput: UpdateTagInput!) {
        updateTag(tagInput: $tagInput) {
            id
        }
    }
`;
